import { AnalyticsContext } from '@carvana/eventable-clickstream';
import {
  TileKit,
  VehicleImage,
  FavoriteVehicle as FavoriteVehicleComponent
} from '@carvana/merch-search';
import { useContext } from 'react';
import type React from 'react';
import Tags from '@/SearchResults/ResultTile/Tags';
import withHandleFavoriteV2 from '@/SearchResults/withHandleFavorite';

const FavoriteVehicle = withHandleFavoriteV2(FavoriteVehicleComponent);

type BaseTopFrameProps = {};

const TopFrame: React.VFC<BaseTopFrameProps> = () => {
  // TODO once showroom is in serenity-ui directory we wont need to pass trackEvent through
  const { trackEvent } = useContext(AnalyticsContext);

  return (
    <TileKit.Frame className="pointer-events-auto top-frame">
      <VehicleImage trackEvent={trackEvent} />
      <TileKit.Pane fullWidth>
        <Tags />
        <FavoriteVehicle />
      </TileKit.Pane>
    </TileKit.Frame>
  );
};

export default TopFrame;
